var loverImage = {
  fmt: function (path, size) {
    if(path==undefined || path==""){

    }
    var file_name = path.substring(0, path.lastIndexOf("."));
    var suffix = path.substring(path.lastIndexOf(".") + 1, path.length);
    return file_name + "_" + size + "." + suffix;
  },
};

export default loverImage;



// WEBPACK FOOTER //
// ./src/utils/image.js